import { LegalAttributeValue } from "../../../../../api/types"
import {
  ObjectValidatorsMap,
  ObjectMapValidator
} from "../../../../../components/Validator"

// TODO: This should be more useful and robust with better comma value support (+value has a string limit of 18).
function isDouble(value: string) {
  return (
    !isNaN(+value) &&
    +value >= -2147483648 &&
    +value <= 2147483647 &&
    value.length <= 18
  )
}

const rangeDoubleValidator = (message: string) => (
  id: string,
  value: {
    value: string
    min?: string
    max?: string
  }
) => {
  if (isDouble(value.value)) {
    if (
      (value.value.length > 0 && value.max && +value.max < +value.value) ||
      (value.value.length > 0 && value.min && +value.min > +value.value)
    ) {
      return {
        valid: false,
        message,
        id
      }
    } else {
      return { valid: true }
    }
  } else {
    return {
      valid: false,
      message,
      id
    }
  }
}

const DecimalNumberValidatorMap: ObjectValidatorsMap<LegalAttributeValue> = {
  min: rangeDoubleValidator(
    "The value must be a valid number with a minimum value of -2147483648, smaller than the given default/maximum value and character count of 18."
  ),
  max: rangeDoubleValidator(
    "The value must be a valid number with a maximum value of 2147483647, larger than the given minimum/default value and character count of 18."
  ),
  default: rangeDoubleValidator(
    "The value must be a valid number between the given minimum and maximum values and character count of 18."
  )
}

const DecimalNumberValidator = new ObjectMapValidator<LegalAttributeValue>(
  DecimalNumberValidatorMap
)

export default DecimalNumberValidator
